import {
  ACTION_WORKFLOW_ISSUE_INVOICE,
  ACTION_WORKFLOW_ISSUE_INVOICE_FAIL,
  ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS,
  ADJUST_ISSUE_INVOICE,
  ADJUST_ISSUE_INVOICE_FAIL,
  ADJUST_ISSUE_INVOICE_SUCCESS,
  ATTACK_FILE_INVOICE_UPLOAD,
  ATTACK_FILE_INVOICE_UPLOAD_FAIL,
  ATTACK_FILE_INVOICE_UPLOAD_RESET,
  ATTACK_FILE_INVOICE_UPLOAD_SUCCESS,
  BK_DATA_NEW,
  CANCEL_ISSUE_INVOICE,
  CANCEL_ISSUE_INVOICE_FAIL,
  CANCEL_ISSUE_INVOICE_SUCCESS,
  CLONE_ENVOICE,
  CLONE_ENVOICE_FAIL,
  CLONE_ENVOICE_SUCCESS,
  CREATE_ISSUE_INVOICE_ENTERPRISE,
  CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL,
  CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_FAIL,
  CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_SUCCESS,
  CREATE_ISSUE_INVOICE_ENTERPRISE_FAIL,
  CREATE_ISSUE_INVOICE_ENTERPRISE_SUCCESS,
  DELETE_ISSUE_INVOICE,
  DELETE_ISSUE_INVOICE_FAIL,
  DELETE_ISSUE_INVOICE_SUCCESS,
  DOWNLOAD_XML_ISSUE_INVOICE,
  DOWNLOAD_XML_ISSUE_INVOICE_FAIL,
  DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS,
  DOWNLOAD_ZIP_INVOICE,
  DOWNLOAD_ZIP_INVOICE_FAIL,
  DOWNLOAD_ZIP_INVOICE_SUCCESS,
  EXPORT_INVOICE,
  EXPORT_INVOICE_FAIL,
  EXPORT_INVOICE_RESET,
  EXPORT_INVOICE_SUCCESS,
  EXPORT_INVOICE_TICKET,
  EXPORT_INVOICE_TICKET_FAIL,
  EXPORT_INVOICE_TICKET_RESET,
  EXPORT_INVOICE_TICKET_SUCCESS,
  EXPORT_INVOICE_WAREHOUSES,
  EXPORT_INVOICE_WAREHOUSES_AGENCY,
  EXPORT_INVOICE_WAREHOUSES_AGENCY_FAIL,
  EXPORT_INVOICE_WAREHOUSES_AGENCY_RESET,
  EXPORT_INVOICE_WAREHOUSES_AGENCY_SUCCESS,
  EXPORT_INVOICE_WAREHOUSES_FAIL,
  EXPORT_INVOICE_WAREHOUSES_RESET,
  EXPORT_INVOICE_WAREHOUSES_SUCCESS,
  GENERATE_NUMBER_INVOICE,
  GENERATE_NUMBER_INVOICE_FAIL,
  GENERATE_NUMBER_INVOICE_SUCCESS,
  GET_CURRENT_TIME,
  GET_CURRENT_TIME_FAIL,
  GET_CURRENT_TIME_SUCCESS,
  GET_DATA_LINK,
  GET_DATA_LINK_FAIL,
  GET_DATA_LINK_RESET,
  GET_DATA_LINK_SUCCESS,
  GET_ENTERPRISE_BY_TAX_CODE,
  GET_ENTERPRISE_BY_TAX_CODE_FAIL,
  GET_ENTERPRISE_BY_TAX_CODE_RESET,
  GET_ENTERPRISE_BY_TAX_CODE_SUCCESS,
  GET_INVOICE_MAX_DATE,
  GET_INVOICE_MAX_DATE_FAIL,
  GET_INVOICE_MAX_DATE_RESET,
  GET_INVOICE_MAX_DATE_SUCCESS,
  GET_INVOICE_MIN_DATE,
  GET_INVOICE_MIN_DATE_FAIL,
  GET_INVOICE_MIN_DATE_RESET,
  GET_INVOICE_MIN_DATE_SUCCESS,
  GET_INVOICE_REPORT_WORD,
  GET_INVOICE_REPORT_WORD_FAIL,
  GET_INVOICE_REPORT_WORD_SUCCESS,
  INVOICE_CAMPAIGN_DETAIL,
  INVOICE_CAMPAIGN_DETAIL_FAIL,
  INVOICE_CAMPAIGN_DETAIL_RESET,
  INVOICE_CAMPAIGN_DETAIL_SUCCESS,
  INVOICE_CAMPAIGN_LIST,
  INVOICE_CAMPAIGN_LIST_FAIL,
  INVOICE_CAMPAIGN_LIST_SUCCESS,
  ISSUE_INVOICE_CREATE,
  ISSUE_INVOICE_CREATE_FAIL,
  ISSUE_INVOICE_CREATE_RESET,
  ISSUE_INVOICE_CREATE_SUCCESS,
  ISSUE_INVOICE_DETAIL,
  ISSUE_INVOICE_DETAIL_FAIL,
  ISSUE_INVOICE_DETAIL_RESET,
  ISSUE_INVOICE_DETAIL_SUCCESS,
  ISSUE_INVOICE_EDIT,
  ISSUE_INVOICE_EDIT_FAIL,
  ISSUE_INVOICE_EDIT_RESET,
  ISSUE_INVOICE_EDIT_SUCCESS,
  ISSUE_INVOICE_LIST,
  ISSUE_INVOICE_LIST_COLUMN,
  ISSUE_INVOICE_LIST_FAIL,
  ISSUE_INVOICE_LIST_RESET,
  ISSUE_INVOICE_LIST_SALE_HAVE_CODE_COLUMN,
  ISSUE_INVOICE_LIST_SALE_NONE_CODE_COLUMN,
  ISSUE_INVOICE_LIST_SUCCESS,
  ISSUE_INVOICE_LIST_VAT_NONE_CODE_COLUMN,
  LOAD_CONFIG_INVOICE_FIELD,
  LOAD_CONFIG_INVOICE_FIELD_FAIL,
  LOAD_CONFIG_INVOICE_FIELD_RESET,
  LOAD_CONFIG_INVOICE_FIELD_SUCCESS,
  PREVIEW_PDF_ISSUE_INVOICE,
  PREVIEW_PDF_ISSUE_INVOICE_FAIL,
  PREVIEW_PDF_ISSUE_INVOICE_SUCCESS,
  RELEASE_CAMPAIGNS_INVOICE,
  RELEASE_CAMPAIGNS_INVOICE_FAIL,
  RELEASE_CAMPAIGNS_INVOICE_RESET,
  RELEASE_CAMPAIGNS_INVOICE_SUCCESS,
  RELEASE_ISSUE_INVOICE,
  RELEASE_ISSUE_INVOICE_FAIL,
  RELEASE_ISSUE_INVOICE_SUCCESS,
  RELEASE_TAX_DEDUCT,
  RELEASE_TAX_DEDUCT_FAIL,
  RELEASE_TAX_DEDUCT_RESET,
  RELEASE_TAX_DEDUCT_SUCCESS,
  REMOVE_FILE_INVOICE,
  REMOVE_FILE_INVOICE_FAIL,
  REMOVE_FILE_INVOICE_RESET,
  REMOVE_FILE_INVOICE_SUCCESS,
  REPLACE_ISSUE_INVOICE,
  REPLACE_ISSUE_INVOICE_FAIL,
  REPLACE_ISSUE_INVOICE_SUCCESS,
  RESET_ACTION_WORKFLOW_ISSUE_INVOICE,
  RESET_ADJUST_ISSUE_INVOICE,
  RESET_BK_DATA_NEW,
  RESET_CANCEL_ISSUE_INVOICE,
  RESET_CLONE_ENVOICE,
  RESET_CREATE_ISSUE_INVOICE_ENTERPRISE,
  RESET_CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL,
  RESET_DELETE_ISSUE_INVOICE,
  RESET_DOWNLOAD_XML_ISSUE_INVOICE,
  RESET_DOWNLOAD_ZIP_INVOICE,
  RESET_GENERATE_NUMBER_INVOICE,
  RESET_GET_INVOICE_REPORT_WORD,
  RESET_PREVIEW_PDF_ISSUE_INVOICE,
  RESET_RELEASE_ISSUE_INVOICE,
  RESET_REPLACE_ISSUE_INVOICE,
  RESET_SEND_MAIL_INVOICE,
  RESET_TRANSFER_USB_INVOICE,
  SEND_MAIL_INVOICE,
  SEND_MAIL_INVOICE_FAIL,
  SEND_MAIL_INVOICE_SUCCESS,
  SET_COLUMN_VISIBLE_INVOICE_CAMPAIGN_LIST,
  TRANSFER_USB_INVOICE,
  TRANSFER_USB_INVOICE_FAIL,
  TRANSFER_USB_INVOICE_SUCCESS,
  UPLOAD_CAMPAIGNS_INVOICE,
  UPLOAD_CAMPAIGNS_INVOICE_FAIL,
  UPLOAD_CAMPAIGNS_INVOICE_RESET,
  UPLOAD_CAMPAIGNS_INVOICE_SUCCESS,
  UPLOAD_FILE_INVOICE,
  UPLOAD_FILE_INVOICE_FAIL,
  UPLOAD_FILE_INVOICE_RESET,
  UPLOAD_FILE_INVOICE_SUCCESS,
  UPLOAD_TAX_DEDUCT,
  UPLOAD_TAX_DEDUCT_FAIL,
  UPLOAD_TAX_DEDUCT_RESET,
  UPLOAD_TAX_DEDUCT_SUCCESS,
} from "./actionTypes";

// List Issue Invoice
export const listIssueInvoice = (
  params = {},
  typeInvoiceAnother,
  showLoading = true
) => ({
  type: ISSUE_INVOICE_LIST,
  payload: { params },
  typeInvoiceAnother,
  showLoading,
});

export const listIssueInvoiceSuccess = data => ({
  type: ISSUE_INVOICE_LIST_SUCCESS,
  payload: data,
});

export const listIssueInvoiceFail = error => ({
  type: ISSUE_INVOICE_LIST_FAIL,
  payload: error,
});

export const resetListIssueInvoice = () => ({
  type: ISSUE_INVOICE_LIST_RESET,
  payload: {},
});

export const setListIssueInvoiceColumn = (field, value) => ({
  type: ISSUE_INVOICE_LIST_COLUMN,
  payload: { field, value },
});

export const setListIssueInvoiceVATNoneCodeColumn = (field, value) => ({
  type: ISSUE_INVOICE_LIST_VAT_NONE_CODE_COLUMN,
  payload: { field, value },
});

export const setListIssueInvoiceSaleHaveCodeColumn = (field, value) => ({
  type: ISSUE_INVOICE_LIST_SALE_HAVE_CODE_COLUMN,
  payload: { field, value },
});

export const setListIssueInvoiceSaleNoneCodeColumn = (field, value) => ({
  type: ISSUE_INVOICE_LIST_SALE_NONE_CODE_COLUMN,
  payload: { field, value },
});

// Create Issue Invoice
export const createIssueInvoice = (data, typeInvoiceAnother) => ({
  type: ISSUE_INVOICE_CREATE,
  payload: { data },
  typeInvoiceAnother,
});

export const createIssueInvoiceSuccess = data => ({
  type: ISSUE_INVOICE_CREATE_SUCCESS,
  payload: data,
});

export const createIssueInvoiceFail = error => ({
  type: ISSUE_INVOICE_CREATE_FAIL,
  payload: error,
});

export const resetCreateIssueInvoice = () => ({
  type: ISSUE_INVOICE_CREATE_RESET,
  payload: {},
});

// EDIT Issue Invoice
//auto_sign int 0 => mặc định không có , 1 => có tự ký
export const editIssueInvoice = (
  data,
  id,
  typeInvoiceAnother,
  auto_sign = 0
) => ({
  type: ISSUE_INVOICE_EDIT,
  payload: { data },
  id,
  typeInvoiceAnother,
  auto_sign,
});

export const editIssueInvoiceSuccess = data => ({
  type: ISSUE_INVOICE_EDIT_SUCCESS,
  payload: data,
});

export const editIssueInvoiceFail = error => ({
  type: ISSUE_INVOICE_EDIT_FAIL,
  payload: error,
});

export const resetEditIssueInvoice = () => ({
  type: ISSUE_INVOICE_EDIT_RESET,
  payload: {},
});

// Replace Issue Invoice
export const getCloneEnvoice = (id, typeInvoiceAnother, approveStatus) => ({
  type: CLONE_ENVOICE,
  id,
  typeInvoiceAnother,
  approveStatus,
});

export const getCloneEnvoiceSuccess = data => ({
  type: CLONE_ENVOICE_SUCCESS,
  data,
});

export const getCloneEnvoiceFail = error => ({
  type: CLONE_ENVOICE_FAIL,
  error,
});
export const resetCloneEnvoice = () => ({
  type: RESET_CLONE_ENVOICE,
});

// Replace Issue Invoice
export const replaceIssueInvoice = (
  id_root,
  attach_ids,
  data,
  typeInvoiceAnother,
  infoTT32
) => ({
  type: REPLACE_ISSUE_INVOICE,
  id_root,
  attach_ids,
  data,
  typeInvoiceAnother,
  infoTT32,
});

export const replaceIssueInvoiceSuccess = data => ({
  type: REPLACE_ISSUE_INVOICE_SUCCESS,
  data,
});

export const replaceIssueInvoiceFail = error => ({
  type: REPLACE_ISSUE_INVOICE_FAIL,
  error,
});

export const resetReplaceIssueInvoice = () => ({
  type: RESET_REPLACE_ISSUE_INVOICE,
});

// Adjust Issue Invoice
export const adjustIssueInvoice = (
  id_root,
  attach_ids,
  adjust_mod,
  data,
  typeInvoiceAnother
) => ({
  type: ADJUST_ISSUE_INVOICE,
  id_root,
  attach_ids,
  adjust_mod,
  data,
  typeInvoiceAnother,
});

export const adjustIssueInvoiceSuccess = data => ({
  type: ADJUST_ISSUE_INVOICE_SUCCESS,
  data,
});

export const adjustIssueInvoiceFail = error => ({
  type: ADJUST_ISSUE_INVOICE_FAIL,
  error,
});

export const resetAdjustIssueInvoice = () => ({
  type: RESET_ADJUST_ISSUE_INVOICE,
});

// TODO
// Detail Issue Invoice
export const getDetailIssueInvoice = (
  id,
  typeInvoiceAnother,
  data = null,
  isAdjustDecrease = false
) => ({
  type: ISSUE_INVOICE_DETAIL,
  id,
  typeInvoiceAnother,
  data,
  isAdjustDecrease,
});

export const getDetailIssueInvoiceSuccess = data => ({
  type: ISSUE_INVOICE_DETAIL_SUCCESS,
  data,
});

export const getDetailIssueInvoiceFail = error => ({
  type: ISSUE_INVOICE_DETAIL_FAIL,
  payload: error,
});
export const resetGetDetailIssueInvoice = () => ({
  type: ISSUE_INVOICE_DETAIL_RESET,
  payload: {},
});

//
// List Issue Invoice
export const loadConfigInvoiceField = () => ({
  type: LOAD_CONFIG_INVOICE_FIELD,
});

export const loadConfigInvoiceFieldSuccess = (
  businessUnitInfo,
  listCurrency,
  listVat,
  listPaymentMethod
) => ({
  type: LOAD_CONFIG_INVOICE_FIELD_SUCCESS,
  businessUnitInfo,
  listCurrency,
  listVat,
  listPaymentMethod,
});

export const loadConfigInvoiceFieldFail = error => ({
  type: LOAD_CONFIG_INVOICE_FIELD_FAIL,
  error: error,
});

export const resetloadConfigInvoiceField = () => ({
  type: LOAD_CONFIG_INVOICE_FIELD_RESET,
});

// GET_ENTERPRISE_BY_TAX_CODE
export const getEnterpriseByTaxCode = taxCode => ({
  type: GET_ENTERPRISE_BY_TAX_CODE,
  taxCode,
});

export const getEnterpriseByTaxCodeSuccess = data => ({
  type: GET_ENTERPRISE_BY_TAX_CODE_SUCCESS,
  data,
});

export const getEnterpriseByTaxCodeFail = error => ({
  type: GET_ENTERPRISE_BY_TAX_CODE_FAIL,
  error: error,
});

export const resetGetEnterpriseByTaxCode = () => ({
  type: GET_ENTERPRISE_BY_TAX_CODE_RESET,
});

// DOWNLOAD_XML_ISSUE_INVOICE
export const downloadXmlIssueInvoice = (
  resource_id,
  fileDownloadName,
  responseType,
  typeInvoiceAnother,
  typeFile = ".xml"
) => ({
  type: DOWNLOAD_XML_ISSUE_INVOICE,
  resource_id,
  fileDownloadName,
  responseType,
  typeInvoiceAnother,
  typeFile,
});

export const downloadXmlIssueInvoiceSuccess = (
  fileDownloadResponse,
  fileDownload,
  fileDownloadName
) => ({
  type: DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS,
  fileDownloadResponse,
  fileDownload,
  fileDownloadName,
});

export const downloadXmlIssueInvoiceFail = error => ({
  type: DOWNLOAD_XML_ISSUE_INVOICE_FAIL,
  error,
});
export const resetDownloadXmlIssueInvoice = error => ({
  type: RESET_DOWNLOAD_XML_ISSUE_INVOICE,
});

// Phát hành hóa đơn
export const releaseIssueInvoice = (
  id,
  typeSend,
  typeInvoiceAnother,
  transferData = null,
  isCreateAdjust = false,
  idAdjust
) => ({
  type: RELEASE_ISSUE_INVOICE,
  id,
  typeSend,
  typeInvoiceAnother,
  transferData,
  isCreateAdjust,
  idAdjust,
});

export const releaseIssueInvoiceSuccess = adjustAll => ({
  type: RELEASE_ISSUE_INVOICE_SUCCESS,
  adjustAll,
});

export const releaseIssueInvoiceFail = error => ({
  type: RELEASE_ISSUE_INVOICE_FAIL,
  error,
});
export const resetReleaseIssueInvoice = () => ({
  type: RESET_RELEASE_ISSUE_INVOICE,
});

// transferUsbInvoice
// typeSend
// REGISTER: 1,
// INVOICE: 2,
// HDSS: 3, // Thông báo HD sai sót
// HDTH: 4, // bảng tổng hợp
// WAREHOUSES: 6, //Phiếu xuất kho
export const transferUsbInvoice = (id, typeSend, content) => ({
  type: TRANSFER_USB_INVOICE,
  id,
  typeSend,
  content,
});

export const transferUsbInvoiceSuccess = data => ({
  type: TRANSFER_USB_INVOICE_SUCCESS,
  data,
});

export const transferUsbInvoiceFail = error => ({
  type: TRANSFER_USB_INVOICE_FAIL,
  error,
});
export const resetTransferUsbInvoice = error => ({
  type: RESET_TRANSFER_USB_INVOICE,
});
// generateNumberInvoice
export const generateNumberInvoice = (id, typeInvoiceAnother) => ({
  type: GENERATE_NUMBER_INVOICE,
  id,
  typeInvoiceAnother,
});

export const generateNumberInvoiceSuccess = data => ({
  type: GENERATE_NUMBER_INVOICE_SUCCESS,
  data,
});

export const generateNumberInvoiceFail = error => ({
  type: GENERATE_NUMBER_INVOICE_FAIL,
  error,
});
export const resetGenerateNumberInvoice = () => ({
  type: RESET_GENERATE_NUMBER_INVOICE,
});

// PREVIEW_PDF_ISSUE_INVOICE
export const previewPdfIssueInvoice = (
  id,
  isPolicy = false,
  isConvert = false,
  isNoneCopy = false,
  isTaxDeduct = false,
  isTaxDeductRegistry = false,
  path = null
) => ({
  type: PREVIEW_PDF_ISSUE_INVOICE,
  id,
  isPolicy,
  isConvert,
  isNoneCopy,
  isTaxDeduct,
  isTaxDeductRegistry,
  path,
});

// PREVIEW_PDF Success
export const previewPdfIssueInvoiceSuccess = data => ({
  type: PREVIEW_PDF_ISSUE_INVOICE_SUCCESS,
  data,
});

// previewPdfIssueInvoiceFail
export const previewPdfIssueInvoiceFail = error => ({
  type: PREVIEW_PDF_ISSUE_INVOICE_FAIL,
  error,
});

// resetPreviewFile
export const resetPreviewPdfIssueInvoice = () => ({
  type: RESET_PREVIEW_PDF_ISSUE_INVOICE,
});

// Xóa hóa đơn
export const deleteIssueInvoice = (id, typeInvoiceAnother) => ({
  type: DELETE_ISSUE_INVOICE,
  id,
  typeInvoiceAnother,
});

export const deleteIssueInvoiceSuccess = () => ({
  type: DELETE_ISSUE_INVOICE_SUCCESS,
});

export const deleteIssueInvoiceFail = error => ({
  type: DELETE_ISSUE_INVOICE_FAIL,
  error,
});
export const resetDeleteIssueInvoice = () => ({
  type: RESET_DELETE_ISSUE_INVOICE,
});

// Hủy hóa đơn
export const cancelIssueInvoice = (
  listInvoice,
  typeCancel,
  typeInvoiceAnother,
  attach_ids
) => ({
  type: CANCEL_ISSUE_INVOICE,
  listInvoice,
  typeCancel,
  typeInvoiceAnother,
  attach_ids,
});

export const cancelIssueInvoiceSuccess = () => ({
  type: CANCEL_ISSUE_INVOICE_SUCCESS,
});

export const cancelIssueInvoiceFail = error => ({
  type: CANCEL_ISSUE_INVOICE_FAIL,
  error,
});
export const resetCancelIssueInvoice = () => ({
  type: RESET_CANCEL_ISSUE_INVOICE,
});

// Gửi mail hóa đơn cho khách hàng
export const sendMailInvoice = (
  id,
  listEmail,
  isInvoiceError = false,
  path = null
) => ({
  type: SEND_MAIL_INVOICE,
  id,
  listEmail,
  isInvoiceError,
  path,
});

export const sendMailInvoiceSuccess = () => ({
  type: SEND_MAIL_INVOICE_SUCCESS,
});

export const sendMailInvoiceFail = error => ({
  type: SEND_MAIL_INVOICE_FAIL,
  error,
});
export const resetSendMailInvoice = () => ({
  type: RESET_SEND_MAIL_INVOICE,
});

// uploadAttackFileInvoice
export const uploadAttackFileInvoice = (file, type = "", isGlobal = false) => ({
  type: ATTACK_FILE_INVOICE_UPLOAD,
  payload: { file, type, isGlobal },
});

export const uploadAttackFileInvoiceSuccess = id => ({
  type: ATTACK_FILE_INVOICE_UPLOAD_SUCCESS,
  payload: { id },
});

export const uploadAttackFileInvoiceFail = (error, type) => ({
  type: ATTACK_FILE_INVOICE_UPLOAD_FAIL,
  payload: { error, type },
});

export const resetUploadAttackFileInvoice = () => ({
  type: ATTACK_FILE_INVOICE_UPLOAD_RESET,
  payload: {},
});

// export biên bản
export const getInvoiceReportWord = (id, typeReport, fileName) => ({
  type: GET_INVOICE_REPORT_WORD,
  id,
  typeReport,
  fileName,
});

export const getInvoiceReportWordSuccess = (
  fileDownload,
  fileDownloadName
) => ({
  type: GET_INVOICE_REPORT_WORD_SUCCESS,
  fileDownload,
  fileDownloadName,
});

export const getInvoiceReportWordFail = error => ({
  type: GET_INVOICE_REPORT_WORD_FAIL,
  error,
});

export const resetGetInvoiceReportWord = () => ({
  type: RESET_GET_INVOICE_REPORT_WORD,
});

// Work flow invoice
// SUBMIT/APPROVE/REJECT
export const actionWorkflowIssueInvoice = (id, typeWorkflow, note, patch) => ({
  type: ACTION_WORKFLOW_ISSUE_INVOICE,
  id,
  typeWorkflow,
  note,
  patch,
});

export const actionWorkflowIssueInvoiceSuccess = typeWorkflow => ({
  type: ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS,
  typeWorkflow,
});

export const actionWorkflowIssueInvoiceFail = (error, typeWorkflow) => ({
  type: ACTION_WORKFLOW_ISSUE_INVOICE_FAIL,
  error,
  typeWorkflow,
});

export const resetActionWorkflowIssueInvoice = () => ({
  type: RESET_ACTION_WORKFLOW_ISSUE_INVOICE,
});

// Tạo hóa đơn doanh nghiệp từ hóa đơn khách hàng lẻ
export const createIssueInvoiceEnterprise = (id, typeClone) => ({
  type: CREATE_ISSUE_INVOICE_ENTERPRISE,
  id,
  typeClone,
});

export const createIssueInvoiceEnterpriseSuccess = data => ({
  type: CREATE_ISSUE_INVOICE_ENTERPRISE_SUCCESS,
  data,
});

export const createIssueInvoiceEnterpriseFail = error => ({
  type: CREATE_ISSUE_INVOICE_ENTERPRISE_FAIL,
  error,
});

export const resetCreateIssueInvoiceEnterprise = () => ({
  type: RESET_CREATE_ISSUE_INVOICE_ENTERPRISE,
});

// Tạo hóa đơn điều chỉnh giảm 100%
export const createIssueInvoiceEnterpriseAdjustAll = id => ({
  type: CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL,
  id,
});

export const createIssueInvoiceEnterpriseAdjustAllSuccess = data => ({
  type: CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_SUCCESS,
  data,
});

export const createIssueInvoiceEnterpriseAdjustAllFail = error => ({
  type: CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_FAIL,
  error,
});

export const resetCreateIssueInvoiceEnterpriseAdjustAll = () => ({
  type: RESET_CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL,
});

// upload biên bản đính kèm cho hóa đơn
export const uploadFileInvoice = (root_id, attach_ids) => ({
  type: UPLOAD_FILE_INVOICE,
  root_id,
  attach_ids,
});

export const uploadFileInvoiceSuccess = () => ({
  type: UPLOAD_FILE_INVOICE_SUCCESS,
});

export const uploadFileInvoiceFail = error => ({
  type: UPLOAD_FILE_INVOICE_FAIL,
  error,
});

export const resetUploadFileInvoice = () => ({
  type: UPLOAD_FILE_INVOICE_RESET,
});

// Xóa biên bản đính kèm
export const removeFileInvoice = id => ({
  type: REMOVE_FILE_INVOICE,
  id,
});

export const removeFileInvoiceSuccess = id => ({
  type: REMOVE_FILE_INVOICE_SUCCESS,
  id,
});

export const removeFileInvoiceFail = error => ({
  type: REMOVE_FILE_INVOICE_FAIL,
  error,
});

export const resetRemoveFileInvoice = () => ({
  type: REMOVE_FILE_INVOICE_RESET,
});

// Xuất hóa đơn
export const exportInvoice = (
  dataExport,
  fileName,
  path,
  invoiceReportType
) => ({
  type: EXPORT_INVOICE,
  dataExport,
  fileName,
  path,
  invoiceReportType,
});

export const exportInvoiceSuccess = (
  fileDownload,
  fileDownloadName,
  reportId
) => ({
  type: EXPORT_INVOICE_SUCCESS,
  fileDownload,
  fileDownloadName,
  reportId,
});

export const exportInvoiceFail = error => ({
  type: EXPORT_INVOICE_FAIL,
  error,
});

export const resetExportInvoice = () => ({
  type: EXPORT_INVOICE_RESET,
});

//Xuất tem phiếu
export const exportInvoiceTicket = (dataExport, fileName) => ({
  type: EXPORT_INVOICE_TICKET,
  dataExport,
  fileName,
});

export const exportInvoiceTicketSuccess = (fileDownload, fileDownloadName) => ({
  type: EXPORT_INVOICE_TICKET_SUCCESS,
  fileDownload,
  fileDownloadName,
});

export const exportInvoiceTicketFail = error => ({
  type: EXPORT_INVOICE_TICKET_FAIL,
  error,
});

export const resetExportInvoiceTicket = () => ({
  type: EXPORT_INVOICE_TICKET_RESET,
});

// Phiếu xuất kho kiêm vận chuyển nội bộ
export const exportInvoiceWarehouses = (dataExport, fileName) => ({
  type: EXPORT_INVOICE_WAREHOUSES,
  dataExport,
  fileName,
});

export const exportInvoiceWarehousesSuccess = (
  fileDownload,
  fileDownloadName
) => ({
  type: EXPORT_INVOICE_WAREHOUSES_SUCCESS,
  fileDownload,
  fileDownloadName,
});

export const exportInvoiceWarehousesFail = error => ({
  type: EXPORT_INVOICE_WAREHOUSES_FAIL,
  error,
});

export const resetExportInvoiceWarehouses = () => ({
  type: EXPORT_INVOICE_WAREHOUSES_RESET,
});

// Xuất phiếu xuất kho gửi bán đại lý
export const exportInvoiceWarehousesAgency = (dataExport, fileName) => ({
  type: EXPORT_INVOICE_WAREHOUSES_AGENCY,
  dataExport,
  fileName,
});

export const exportInvoiceWarehousesAgencySuccess = (
  fileDownload,
  fileDownloadName
) => ({
  type: EXPORT_INVOICE_WAREHOUSES_AGENCY_SUCCESS,
  fileDownload,
  fileDownloadName,
});

export const exportInvoiceWarehousesAgencyFail = error => ({
  type: EXPORT_INVOICE_WAREHOUSES_AGENCY_FAIL,
  error,
});

export const resetExportInvoiceWarehousesAgency = () => ({
  type: EXPORT_INVOICE_WAREHOUSES_AGENCY_RESET,
});

// Danh sách bảng thống kê
export const getInvoiceCampaignList = params => ({
  type: INVOICE_CAMPAIGN_LIST,
  params,
});

export const getInvoiceCampaignListSuccess = (listData, totalCount) => ({
  type: INVOICE_CAMPAIGN_LIST_SUCCESS,
  listData,
  totalCount,
});

export const getInvoiceCampaignListFail = error => ({
  type: INVOICE_CAMPAIGN_LIST_FAIL,
  error,
});

export const resetInvoiceCampaignList = error => ({
  type: INVOICE_CAMPAIGN_LIST,
});

export const setColumnVisibleInvoiceCampaignList = (field, value) => ({
  type: SET_COLUMN_VISIBLE_INVOICE_CAMPAIGN_LIST,
  field,
  value,
});

// upload lô hóa đơn
export const uploadCampaignsInvoice = (typeReport, report_id, store_code) => ({
  type: UPLOAD_CAMPAIGNS_INVOICE,
  typeReport,
  report_id,
  store_code,
});

export const uploadCampaignsInvoiceSuccess = data => ({
  type: UPLOAD_CAMPAIGNS_INVOICE_SUCCESS,
  data,
});

export const uploadCampaignsInvoiceFail = error => ({
  type: UPLOAD_CAMPAIGNS_INVOICE_FAIL,
  error,
});

export const resetUploadCampaignsInvoice = () => ({
  type: UPLOAD_CAMPAIGNS_INVOICE_RESET,
});

// Phát hành lô hóa đơn
export const releaseCampaignsInvoice = id => ({
  type: RELEASE_CAMPAIGNS_INVOICE,
  id,
});

export const releaseCampaignsInvoiceSuccess = () => ({
  type: RELEASE_CAMPAIGNS_INVOICE_SUCCESS,
});

export const releaseCampaignsInvoiceFail = error => ({
  type: RELEASE_CAMPAIGNS_INVOICE_FAIL,
  error,
});

export const resetReleaseCampaignsInvoice = () => ({
  type: RELEASE_CAMPAIGNS_INVOICE_RESET,
});

// Detail lô hóa đơn
export const invoiceCampaignDetail = id => ({
  type: INVOICE_CAMPAIGN_DETAIL,
  id,
});

export const invoiceCampaignDetailSuccess = data => ({
  type: INVOICE_CAMPAIGN_DETAIL_SUCCESS,
  data,
});

export const invoiceCampaignDetailFail = error => ({
  type: INVOICE_CAMPAIGN_DETAIL_FAIL,
  error,
});

export const resetInvoiceCampaignDetail = () => ({
  type: INVOICE_CAMPAIGN_DETAIL_RESET,
});

// Get thông tin child/parent của hóa đơn thay thế/ điều chỉnh
export const getDataLink = (id, isGetChild = false) => ({
  type: GET_DATA_LINK,
  id,
  isGetChild,
});

export const getDataLinkSuccess = (data, isGetChild) => ({
  type: GET_DATA_LINK_SUCCESS,
  data,
  isGetChild,
});

export const getDataLinkFail = error => ({
  type: GET_DATA_LINK_FAIL,
  error,
});

export const resetGetDataLink = () => ({
  type: GET_DATA_LINK_RESET,
});

// getInvoiceMaxDate
export const getInvoiceMaxDate = (khmhdon, khhdon, bu_code) => ({
  type: GET_INVOICE_MAX_DATE,
  khmhdon,
  khhdon,
  bu_code,
});

export const getInvoiceMaxDateSuccess = data => ({
  type: GET_INVOICE_MAX_DATE_SUCCESS,
  data,
});

export const getInvoiceMaxDateFail = error => ({
  type: GET_INVOICE_MAX_DATE_FAIL,
  error,
});

export const resetGetInvoiceMaxDate = () => ({
  type: GET_INVOICE_MAX_DATE_RESET,
});

// getInvoiceMinDate
export const getInvoiceMinDate = (khmhdon, khhdon, bu_code) => ({
  type: GET_INVOICE_MIN_DATE,
  khmhdon,
  khhdon,
  bu_code,
});

export const getInvoiceMinDateSuccess = data => ({
  type: GET_INVOICE_MIN_DATE_SUCCESS,
  data,
});

export const getInvoiceMinDateFail = error => ({
  type: GET_INVOICE_MIN_DATE_FAIL,
  error,
});

export const resetGetInvoiceMinDate = () => ({
  type: GET_INVOICE_MIN_DATE_RESET,
});

// downloadZipInvoice
export const downloadZipInvoice = (
  ids,
  typeFile, // pdf , xml,
  fileName
) => ({
  type: DOWNLOAD_ZIP_INVOICE,
  ids,
  typeFile,
  fileName,
});

export const downloadZipInvoiceSuccess = (
  fileDownload,
  fileDownloadName,
  dataResponse
) => ({
  type: DOWNLOAD_ZIP_INVOICE_SUCCESS,
  fileDownload,
  fileDownloadName,
  dataResponse,
});

export const downloadZipInvoiceFail = error => ({
  type: DOWNLOAD_ZIP_INVOICE_FAIL,
  error,
});

export const resetDownloadZipInvoice = () => ({
  type: RESET_DOWNLOAD_ZIP_INVOICE,
});

export const backupDataNew = data => ({
  type: BK_DATA_NEW,
  data,
});

export const resetBackupDataNew = () => ({
  type: RESET_BK_DATA_NEW,
});

// Lấy ngày hiện tại theo giờ hệ thống
export const getCurrentTime = () => ({
  type: GET_CURRENT_TIME,
});

export const getCurrentTimeSuccess = data => ({
  type: GET_CURRENT_TIME_SUCCESS,
  data,
});

export const getCurrentTimeFail = error => ({
  type: GET_CURRENT_TIME_FAIL,
  error,
});

// upload chứng từ
export const uploadTaxDeduct = (resource_id, store_code) => ({
  type: UPLOAD_TAX_DEDUCT,
  resource_id,
  store_code,
});

export const uploadTaxDeductSuccess = data => ({
  type: UPLOAD_TAX_DEDUCT_SUCCESS,
  data,
});

export const uploadTaxDeductFail = error => ({
  type: UPLOAD_TAX_DEDUCT_FAIL,
  error,
});

export const resetUploadTaxDeduct = () => ({
  type: UPLOAD_TAX_DEDUCT_RESET,
});

// Phát hành CTKT
export const releaseTaxDeduct = id => ({
  type: RELEASE_TAX_DEDUCT,
  id,
});

export const releaseTaxDeductSuccess = () => ({
  type: RELEASE_TAX_DEDUCT_SUCCESS,
});

export const releaseTaxDeductFail = () => ({
  type: RELEASE_TAX_DEDUCT_FAIL,
});

export const resetReleaseTaxDeduct = () => ({
  type: RELEASE_TAX_DEDUCT_RESET,
});
